module.exports = __webpack_public_path__ + "img/seme_2kl.59688c72.jpg";